module.exports = __webpack_public_path__ + "static/media/report.5db4edbf.jpg";